import React from 'react';

export default function PageHero({ kicker, title, bgImage }) {
  // Mfumo wa usalama kama picha isipopatikana (Fallback color)
  const heroStyle = {
    backgroundImage: bgImage ? `linear-gradient(to bottom, rgba(4, 34, 17, 0.85), rgba(4, 34, 17, 0.65)), url(${bgImage})` : 'var(--primaryColor)',
  };

  return (
    <div className="kukaja-page-hero" style={heroStyle}>
      <div className="container h-100 d-flex align-items-center justify-content-center">
        <div className="hero-content-wrapper text-center">
          
          {/* Kicker: Ndogo, yenye herufi kubwa na nafasi (Uppercase Tracking) */}
          {kicker && (
            <span className="title-font-semi-bold page-hero-kicker text-uppercase mb-2 d-block">
              {kicker}
            </span>
          )}

          {/* Title: Kubwa, Bold, na yenye heshima */}
          <h1 className="title-font-bold page-hero-title text-capitalize">
            {title}
          </h1>
          
        </div>
      </div>
    </div>
  );
}